import { DateTime } from "luxon";
import { Reference } from "../../shared/refs";

export interface PredictiveServiceConfirmation {
  success: boolean;
  dateOfInspection: number;
}
export interface PredictiveServiceHistoryObject {
  id?: string;
  activityType?: string;
  dateOfCreation?: number;
  gateComponent?: Reference;
  dateOfInspection?: number;
  notes?: string;
  status?: string;
}

export class PredictiveServiceHistory {
  private CREATION_DATE_FORMAT = "dd.MM.yyyy";
  private INSPECTION_DATE_FORMAT = "dd.MM.yyyy";
  id?: string;
  dateOfCreation?: string | null;
  doorComponentLabel?: string | null;
  dateOfInspection?: string | null;
  notes?: string;
  status?: string;
  activityType?: string;

  constructor(predictiveServiceHistory: PredictiveServiceHistoryObject) {
    this.id = predictiveServiceHistory.id;
    this.activityType = predictiveServiceHistory.activityType;
    this.dateOfCreation = predictiveServiceHistory.dateOfCreation
      ? DateTime.fromMillis(predictiveServiceHistory.dateOfCreation).toFormat(this.CREATION_DATE_FORMAT)
      : null;
    this.doorComponentLabel = predictiveServiceHistory.gateComponent?.label
      ? predictiveServiceHistory.gateComponent?.label
      : null;
    this.dateOfInspection = predictiveServiceHistory.dateOfInspection
      ? DateTime.fromMillis(predictiveServiceHistory.dateOfInspection).toFormat(this.INSPECTION_DATE_FORMAT)
      : null;
    this.notes = predictiveServiceHistory.notes;
    this.status = predictiveServiceHistory.status;
  }

  set setDateOfInspection(timestamp: number) {
    this.dateOfInspection = DateTime.fromMillis(timestamp).toFormat(this.INSPECTION_DATE_FORMAT);
  }
}
